module.exports = __webpack_public_path__ + "img/flaggstikk_double_1.ff3da489.jpg";